import React from 'react';
import type { ProductCategory } from '../productCategoriesApi';
import CategoryTag from '../category/CategoryTag';

interface CategoryTagPickerProps {
  categories: ProductCategory[];
  value?: string | null;
  onChange?: (value: string) => void;
  disabled?: boolean;
  ariaLabel: string;
}

/**
 * Category choice as the category's own coloured tags (category/CategoryTag,
 * colour chosen on the category card). Acts as a radio
 * group so it works as an antd Form.Item control and with the keyboard.
 */
const CategoryTagPicker: React.FC<CategoryTagPickerProps> = ({
  categories, value, onChange, disabled, ariaLabel,
}) => (
  <div className="product-card-category-pick" role="radiogroup" aria-label={ariaLabel}>
    {categories.map((category) => {
      const selected = category.id === value;
      return (
        <button
          key={category.id}
          type="button"
          role="radio"
          aria-checked={selected}
          disabled={disabled}
          className={selected ? 'product-card-category-choice is-selected' : 'product-card-category-choice'}
          onClick={() => onChange?.(category.id)}
        >
          <CategoryTag categoryId={category.id} name={category.name} color={category.color} size="small" />
        </button>
      );
    })}
  </div>
);

export default CategoryTagPicker;
